import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { BOX_SHADOWS, FONTS } from "../../constants";
import { stateType } from "../../state";
import { BoxHeader } from "../Common/BoxHeader";
import { CorrelationChart } from "./CorrelationChart";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      boxShadow: BOX_SHADOWS,
      backgroundColor: "white",
      height: "510px",
      width: "30%",
      display: "flex",
      flexDirection: "column",
      fontFamily: FONTS,
      borderRadius: "10px",
    },
    correlations: {
      marginTop: "20px",
      width: "100%",
    },
  })
);

export function CorrelationBox({ state }: stateType) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <BoxHeader
        title={"Column Correlations"}
        toolTip={"Shows the correlations between all pairs of columns."}
      ></BoxHeader>
      <div className={classes.correlations}>
        <CorrelationChart state={state}></CorrelationChart>
      </div>
    </div>
  );
}
